var _path, _circle, _path2, _rect, _rect2, _line, _line2, _line3, _path3, _path4, _circle2, _path5, _circle3, _path6, _circle4, _circle5, _circle6, _circle7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFourLongBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 200 10 L 180 10 L 170 20 L 100 25 L 80 35 L 5 90 L 5 110 L 80 165 L 100 175 L 170 180 L 180 190 L 200 190",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 100,
    r: 35,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 205 73 L 130 78 L 130 122 L 205 127 Z",
    fill: "#aaa",
    strokeWidth: 3,
    stroke: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 63,
    height: 15,
    width: 10,
    fill: "#aaa",
    strokeWidth: 3,
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 122,
    height: 15,
    width: 10,
    fill: "#aaa",
    strokeWidth: 3,
    stroke: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 143,
    y1: 89,
    x2: 100,
    y2: 89,
    strokeWidth: 3,
    stroke: "black"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 143,
    y1: 100,
    x2: 100,
    y2: 100,
    strokeWidth: 3,
    stroke: "black"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 143,
    y1: 111,
    x2: 100,
    y2: 111,
    strokeWidth: 3,
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 35 87.5 L 80 80 L 80 120 L 35 112.5 Z",
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 60 100 L 20 97 L 20 103 Z",
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 10,
    cx: 80,
    cy: 150,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 40 145 L 120 160 L 123 155 L 43 140 Z",
    stroke: "black",
    strokeWidth: 3,
    fill: "#aaa"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 10,
    cx: 80,
    cy: 50,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 40 55 L 120 40 L 123 45 L 43 60 Z",
    stroke: "black",
    strokeWidth: 3,
    fill: "#aaa"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 165,
    r: 7,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 155,
    cy: 150,
    r: 7,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 35,
    r: 7,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 155,
    cy: 50,
    r: 7,
    fill: "transparent",
    strokeWidth: 3,
    stroke: "black"
  })), "\n  Sorry, your browser does not support inline SVG.\n");
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourLongBack);
export default __webpack_public_path__ + "static/media/FourLongBack.c04e70d323569b2dc9d81813acd5c522.svg";
export { ForwardRef as ReactComponent };